import { ConnectButton } from '360dialog-connect-button';
import React from 'react';

interface DialogButtonProps {
  domain: string;
  label: string;
  className?: string;
  style?: React.CSSProperties;
}

export function DialogButton({ domain, label, className, style }: DialogButtonProps) {
  return (
    <ConnectButton
      partnerId={process.env.REACT_APP_DIALOG_PARTNER_ID as string}
      callback={(callbackObject) => {
        if (callbackObject.revokedChannels) {
          console.log('Revoked Channel IDs: ' + callbackObject.revokedChannels);
        }
      }}
      className={`ant-btn ant-btn-primary ${className}`} // <-- Insert your own styles via className definition or through inline styling
      style={style}
      label={label}
      queryParameters={{
        redirect_url: `${process.env.REACT_APP_DIALOG_URL}/finish?domain=${domain}`,
      }}
    />
  );
}
